import { BYO_FAVOURITES_STORAGE_KEY } from '../constants';
const localStorageService = {
    load: () => {
        const data = window.localStorage.getItem(BYO_FAVOURITES_STORAGE_KEY);
        if (!data) {
            return [];
        }
        return JSON.parse(data);
    },
    save: (data) => {
        window.localStorage.setItem(BYO_FAVOURITES_STORAGE_KEY, JSON.stringify(data || []));
    },
    remove: () => {
        window.localStorage.removeItem(BYO_FAVOURITES_STORAGE_KEY);
    },
};
export default localStorageService;
